import { Box, Group, Text } from '@mantine/core';
import { brand } from '@/theme/theme';
import type { ReactNode } from 'react';

export interface EyebrowProps {
  children: ReactNode;
  /** Set on a dark surface (client hero); switches the text tone to `onDarkMuted`. */
  onDark?: boolean;
}

/** Small tracked-uppercase label with a yellow dot, used above a title. See frontend-design.md §3. */
export function Eyebrow({ children, onDark = false }: EyebrowProps) {
  return (
    // The dot sits on the first line when a long label wraps (a stat card on a phone).
    <Group gap={8} wrap="nowrap" align="flex-start">
      <Box w={6} h={6} mt={6} bg={brand.yellow} style={{ borderRadius: '50%', flexShrink: 0 }} />
      <Text
        fz={12}
        lh="18px"
        fw={700}
        tt="uppercase"
        c={onDark ? brand.onDarkMuted : brand.textMuted}
        style={{ letterSpacing: '0.14em' }}
      >
        {children}
      </Text>
    </Group>
  );
}
